// The Vault's own name for the folder every holder of the company shares, as the Vault page reads it.
const VAULT_SHARED_FOLDER_NAME = 'Shared Folder';

export const isVaultSharedFolder = (name: string): boolean => name === VAULT_SHARED_FOLDER_NAME;
